// Дрібні форматери UI.

export function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatDuration(ms: number | null | undefined): string {
  if (!ms || ms <= 0) return '—';
  const total = Math.round(ms / 1000);
  if (total < 60) return `${total}с`;
  const m = Math.floor(total / 60);
  const s = total % 60;
  return s ? `${m}хв ${s}с` : `${m}хв`;
}

export function modeLabel(mode: string): string {
  switch (mode) {
    case 'CATEGORY':
      return 'За категорією';
    case 'OFFICIAL_20':
      return 'Іспит';
    case 'RANDOM_20':
      return 'Білет (20 випадкових)';
    case 'HARDEST_100':
      return '100 найскладніших';
    case 'MISTAKES':
      return 'Робота над помилками';
    case 'MARATHON':
      return 'Марафон';
    default:
      return mode;
  }
}
